import { constVoid as o } from "fp-ts/lib/function";
const t = (...r) => o();
export {
  t as v
};
//# sourceMappingURL=voidFn-ri6LwHH4.mjs.map
